import { useIntl } from "react-intl";
import ProgressBanner from "./progress-banner";

interface Props {
  loading?: boolean;
  reviewedCount?: number;
  totalCount?: number;
}

const StockTakeProgressBanner: FC<Props> = ({
  loading,
  reviewedCount,
  totalCount,
}) => {
  const { formatMessage } = useIntl();

  return (
    <ProgressBanner
      label={formatMessage({
        id: "inventory.stockTake.summary.progressBanner.label",
        defaultMessage: "Lots updated",
      })}
      loading={loading}
      numerator={reviewedCount}
      denominator={totalCount}
      color={loading || reviewedCount !== totalCount ? "warning" : "success"}
    />
  );
};

export default StockTakeProgressBanner;
